import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { LanguageManagerService } from 'src/app/_services/languagemanager.service';
import { StorageService } from 'src/app/_services/storage.service';
import { BaseComponent } from 'src/app/common/base/base.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { LanguageService } from 'src/app/_services/language.service';
import { LanguageMessage } from 'src/app/_models/language-message.model.';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  standalone: false,
})
export class HelpComponent extends BaseComponent implements OnInit {

  private userSuscription$!: Subscription;
  private languagesDownloaded$!: Subscription;
  languages = [];
  private languageChanged$!: Subscription;
  public selectedLanguage = '';
  languageMessage: LanguageMessage;
  htmlContact: SafeHtml;
  htmlDocumentation: SafeHtml;

  constructor(
    private storageService: StorageService,
    public override router: Router,
    public override langService: LanguageManagerService,
    private route: ActivatedRoute,
    private languageService: LanguageService,
    private sanitizer: DomSanitizer,
  ) {
    super(router, langService, route);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.languagesDownloaded$ =
      this.langService.languagesDownloaded$.subscribe((languages) => {
        // cuando termina de cargar los idiomas mostramos el desplegable
        // console.log('enrollment languages',languages)
        this.languages = languages;
      });
    this.languageChanged$ = this.langService.languageChanged$.subscribe(
      (selectedLanguage) => {
        // console.log('enrollment selectedLanguage',selectedLanguage)
        // cuando recibimos el evento de cambiar de idioma cambiamos la seleccion del desplegable
        // eso ocurre al cargar la pagina, el desplegable puede poner el primer valor
        // pero podemos tener guardado un idioma determinado seleccionado
        this.selectedLanguage = selectedLanguage;
      }
    );
    // Cargar idiomas disponibles
    this.langService.languagesDownloaded$.subscribe((langs) => {
      this.languages = langs;
    });

    // Sincronizar idioma seleccionado
    this.langService.languageChanged$.subscribe((lang) => {
      this.selectedLanguage = lang;
      this.getLanguageMessage();
    });  
  }

  renderizarHtml(htmlCrudo: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(htmlCrudo);
  }

  getLanguageMessage() {
    let key = 'DCO.DCLAIMS_CONTACT_HELP';
    this.languageService.getLanguageMessage(key, this.selectedLanguage).subscribe({
      next: (response) => {
        this.languageMessage = response;

        let mensaje = this.languageMessage.message;
        mensaje = mensaje.replace(/(\r\n|\n|\r)/gm, "");

        this.htmlContact = this.sanitizer.bypassSecurityTrustHtml(mensaje);
      }
    });

    key = 'DCO.DCLAIMS_DOCUMENTATION_HELP';
    this.languageService.getLanguageMessage(key, this.selectedLanguage).subscribe({
      next: (response) => {
        this.languageMessage = response;

        let mensaje = this.languageMessage.message;
        mensaje = mensaje.replace(/(\r\n|\n|\r)/gm, "");

        this.htmlDocumentation = this.sanitizer.bypassSecurityTrustHtml(mensaje);
      }
    });
  }
}
